import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { showSSOButtons } from "@faire/retailer-visitor-shared/lib/ssoUtils";
import { getAppleSSOClientID } from "@faire/retailer-visitor-shared/serialized-data/getAppleSSOClientID";
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { loadScript } from "@faire/web--source/common/loadScript";
import { logError } from "@faire/web--source/common/logging";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
var APPLE_LOGIN_SCRIPT_NAME = "_appleLogin";
var APPLE_LOGIN_SCRIPT_SRC = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
var DEFAULT_CLIENT_ID = "com.faire.retailer";
var SCOPE = "name email";
var PROVIDER = SocialSignOnProvider.APPLE;
export var isAppleLoginInitialized = function() {
    var _getDocument;
    return !!((_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.getElementById(APPLE_LOGIN_SCRIPT_NAME));
};
export var initializeAppleLogin = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(setSSOLocalizedMessage) {
        var _windowObj_AppleID, _windowObj_AppleID1, windowObj, _getAppleSSOClientID;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(!isAppleLoginInitialized() && showSSOButtons())) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        loadScript(APPLE_LOGIN_SCRIPT_SRC, APPLE_LOGIN_SCRIPT_NAME)
                    ];
                case 1:
                    _state.sent();
                    try {
                        ;
                        windowObj = getWindowOrThrow();
                        if ((windowObj === null || windowObj === void 0 ? void 0 : (_windowObj_AppleID = windowObj.AppleID) === null || _windowObj_AppleID === void 0 ? void 0 : _windowObj_AppleID.auth) && typeof (windowObj === null || windowObj === void 0 ? void 0 : (_windowObj_AppleID1 = windowObj.AppleID) === null || _windowObj_AppleID1 === void 0 ? void 0 : _windowObj_AppleID1.auth.init) === "function") {
                            ;
                            AppleID.auth.init({
                                clientId: (_getAppleSSOClientID = getAppleSSOClientID()) !== null && _getAppleSSOClientID !== void 0 ? _getAppleSSOClientID : DEFAULT_CLIENT_ID,
                                scope: SCOPE,
                                redirectURI: faireBaseUrl(),
                                usePopup: true
                            });
                        }
                    } catch (error) {
                        logError(error, {
                            tags: {
                                signInType: "SSO",
                                provider: PROVIDER,
                                code: "auth_init_failed"
                            }
                        });
                        setSSOLocalizedMessage();
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function initializeAppleLogin(setSSOLocalizedMessage) {
        return _ref.apply(this, arguments);
    };
}();
